import { render } from "./EditTiktok.vue?vue&type=template&id=a7b55ff2&scoped=true"
import script from "./EditTiktok.vue?vue&type=script&lang=js"
export * from "./EditTiktok.vue?vue&type=script&lang=js"

import "./EditTiktok.vue?vue&type=style&index=0&id=a7b55ff2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b55ff2"]])

export default __exports__